import { gql } from '@apollo/client';

export const GetKnowledgeData = gql`
    query getKnowledgeData($agentId: ID!) {
        getKnowledgeData(agentId: $agentId) {
            success
            error
            id
            knowledgeData {
                id
                processingStatus
                source
                active
                sourceType
                text
                createdAt
            }
        }
    }
`;
